import "./TermsConditions.css";
import React, { useState, MouseEvent } from 'react';
// import { jwtDecode } from 'jwt-decode';
// import { useNavigate } from "react-router-dom";

export const TermsConditions = () => {
  let continueEnabled = "pa-btn btn-warning btn-lg";
  let continueDisabled = "pa-btn btn-warning btn-lg disabled";
  const [classes, setClasses] = useState(continueDisabled);
  // const navigate = useNavigate();

  const changeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.checked);
    if (event.target.checked) {
      setClasses(continueEnabled);
    } else {
      setClasses(continueDisabled);
    }
  };

  function continueClicked(event: MouseEvent<HTMLAnchorElement>): void {
    event.preventDefault();

    if (classes === continueEnabled) {
      let authorizationToken = localStorage.getItem('authorizationToken') as string;
      fetch('/api/termsAccept',
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ authorizationToken
          }
        })
        .then(response => {
          if(response.status === 200) {
            console.log('Terms & Conditions accepted')
            response.text().then(authToken => {
              localStorage.setItem('authorizationToken', authToken);
              window.location.href= './home';
            });
          } else{
            console.error('Unable to accept terms & conditions: ', response.statusText);
            window.location.href= './storefrontLogout';
          } 
        })
        .catch(error => {
          console.error('Unable to accept terms & conditions: ', error);
          window.location.href= './storefrontLogout';
        });
    }
  }

  return (
    <main id="main-content" role="main">
      <section className={""}>
        <div className="modal-footer-terms">
          <div className="popupcheckctrls-terms">
            <div id="terms-checbx">
              <input id="accept" name="accept" type="checkbox" onChange={changeClass} />
              <label htmlFor="accept"> Do you accept the <a href="https://www.xfinity.com/Corporate/Customers/Policies/SubscriberAgreement" target='_blank'  rel="noreferrer"><span id="activate-text">Terms of Activation?</span></a></label>
            </div>
          </div>
          <a id="termsContinue" className={classes} onClick={continueClicked}>Continue </a>
        </div>
      </section>
    </main>
  );
}